module.exports = __webpack_public_path__ + "img/1.dc8af7d4.jpeg";